import * as VKID from '@vkid/sdk'
import { useEffect } from 'react'
import { AuthResponse, AuthResponseSchema } from './vk.types'
import { useOauth2LoginMutation } from '../auth/authApi'
const REDIRECT_URL = import.meta.env.VITE_REDIRECT_URL
export type VkOAuthResult = ()=>void
export const useVkOAuth = ():VkOAuthResult => {
    const [query] = useOauth2LoginMutation()
  useEffect(()=>{
    VKID.Config.init({
      app: Number(import.meta.env.VITE_VK_OAUTH_CLIENT_ID),
      redirectUrl: REDIRECT_URL,
      scope: 'email phone',
      responseMode: VKID.ConfigResponseMode.Callback,
      mode: VKID.ConfigAuthMode.InNewWindow
    })
  },[])
  const handleCallbackAuth = (arg:AuthResponse) =>{
    query({
      code: arg.code,
      provider: 'vk',
      code_verifier: '',
      device_id: arg.device_id
    })
  }
  const openDialog = async () => {
    try{
      const response = await VKID.Auth.login()
      const code = AuthResponseSchema.parse(response)
      handleCallbackAuth(code)
    }catch(error){
      console.log(error)
    }
    
  }
  return openDialog
}